// extracted by mini-css-extract-plugin
export default {"cls1":"useMenuActions-cls1__f4c618888afe30f6f12e","cls2":"useMenuActions-cls2___78831fc60b52a87ef33 useMenuActions-cls1__f4c618888afe30f6f12e"};